import { useState, useEffect } from "react";

export function useCountdown(targetIso) {
  const compute = () => {
    const diff = new Date(targetIso).getTime() - Date.now();
    if (isNaN(diff) || diff <= 0) return null;
    return {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff % 86400000) / 3600000),
      mins: Math.floor((diff % 3600000) / 60000),
      secs: Math.floor((diff % 60000) / 1000),
    };
  };
  const [t, setT] = useState(compute);
  useEffect(() => {
    const id = setInterval(() => setT(compute()), 1000);
    return () => clearInterval(id);
  }, [targetIso]);
  return t;
}
